import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=018b704f&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=018b704f&prod&lang=less&scoped=true&"
import style1 from "./Setting.vue?vue&type=style&index=1&id=018b704f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b704f",
  null
  
)

export default component.exports